<template>
  <h3
    class="title"
    v-if="translate(title)"
  >
    {{ translate(title) }}
  </h3>
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'
import { useStyle } from '@/composables/app/useStyle'

const { parent, component } = defineProps({
  parent: { type: Object, required: true },
  component: { type: Object, required: true }
})

const { componentStyle: parentStyle } = useStyle(parent.style)
const { componentStyle: blockStyle } = useStyle(component.style)
const { translate } = useI18n()

const { title } = component.attributes
const color = blockStyle.value.color || parentStyle.value.color
</script>

<style lang="scss" scoped>
.title {
  font-family: $font-family--primary;
  font-weight: bold;
  color: v-bind(color);
}
</style>